export const COMPANY_LEGAL_NAME = "IBERBRIT, SL";
export const COMPANY_BRAND_NAME = "Taxby";
export const COMPANY_CIF = "B30776876";
export const COMPANY_ADDRESS_LINE = "Gran Vía 64, Planta 03, Puerta D";
export const COMPANY_POSTAL_CODE = "28013";
export const COMPANY_CITY = "Madrid";
export const COMPANY_ADDRESS_FULL = `${COMPANY_ADDRESS_LINE}, ${COMPANY_POSTAL_CODE} ${COMPANY_CITY}`;
export const COMPANY_CONTACT_EMAIL = "info@taxby.io";
export const COMPANY_NOTIFICATIONS_EMAIL = "notificaciones@taxby.io";
export const COMPANY_NOTIFY_EMAIL = "Michael@iberbrit.com";

export const SOFTWARE_NAME = "Taxby";
export const SOFTWARE_CODE = "TAXBY";
export const SOFTWARE_VERSION = "1.0.0";
export const DECLARATION_DATE = "14 de julio de 2026";
export const DECLARATION_PLACE = "Madrid (Madrid) – España";
export const SOFTWARE_PRODUCT_URL = "https://www.taxby.io";
export const SOFTWARE_DECLARATION_URL = "https://www.taxby.io/declaracion-responsable";
